import CloudWatchMonitor from './CloudWatchMonitor';
import SentryMonitor from './SentryMonitor';

/** @typedef {{captureException?: (error: unknown) => void, initialize?: () => void}} MonitorDriver */

/** @type {Record<string, MonitorDriver>} */
const drivers = {
	cloudwatch: CloudWatchMonitor,
	sentry: SentryMonitor,
};

/**
 * @param {string|undefined} value
 * @param {string[]} [fallback]
 * @returns {string[]}
 */
function parseDrivers(value, fallback = []) {
	if (!value) {
		return fallback;
	}

	try {
		const parsed = JSON.parse(value);

		if (Array.isArray(parsed)) {
			return parsed;
		}
	} catch {
		// Fall back to comma-separated parsing.
	}

	return value
		.split(',')
		.map((driver) => driver.trim().toLowerCase())
		.filter(Boolean);
}

/**
 * @param {string} channel
 * @returns {MonitorDriver[]}
 */
function resolve(channel) {
	const configuredDrivers = parseDrivers(
		process.env[`REACT_APP_MONITOR_${channel}_DRIVERS`],
		[]
	);

	return configuredDrivers
		.map((driverName) => drivers[driverName])
		.filter(Boolean);
}

const MonitorManager = {
	/**
	 * @param {unknown} error
	 * @returns {void}
	 */
	captureException(error) {
		resolve('ERROR').forEach((driver) => {
			if (typeof driver.captureException === 'function') {
				driver.captureException(error);
			}
		});
	},

	initialize() {
		resolve('APP').forEach((driver) => {
			if (typeof driver.initialize === 'function') {
				driver.initialize();
			}
		});
	},
};

export default MonitorManager;
